import { YStack, XStack, Text } from "tamagui";

import { v2 } from "@screen/Home/pages/GasShop/skin";
import SectionLabel from "../components/ui/SectionLabel";
import ListContainer from "../components/ui/ListContainer";
import type { BillPaymentRecord } from "../API/handleBillsAPI";
import { money, paidAtLabel, paymentDirectionPrefix } from "./billDisplay";

const tabular = { fontVariantNumeric: "tabular-nums" as const };

/** 收款紀錄（同一次收款已由後端合併），獨立一張卡，放在帳單本體下面；沒有紀錄就不顯示 */
export default function BillPaymentsCard({ payments }: { payments: BillPaymentRecord[] }) {
  if (payments.length === 0) return null;
  return (
    <YStack>
      <SectionLabel
        title="收款紀錄"
        right={
          <Text fontSize={12} color={v2.sub}>
            {payments.length} 筆
          </Text>
        }
      />
      <ListContainer>
        {payments.map((p, i) => (
          <XStack
            key={`${p.paid_at}-${i}`}
            jc="space-between"
            ai="center"
            gap="$3"
            px="$3.5"
            py="$3"
            bbw={i === payments.length - 1 ? 0 : 1}
            bbc={v2.divider}>
            <YStack gap="$1" f={1}>
              <Text fontSize={13} fontWeight="700" color={v2.title}>
                {paidAtLabel(p.paid_at)}
              </Text>
              {p.pay_ways.length > 0 && (
                <Text fontSize={11} color={v2.sub}>
                  {p.pay_ways.join("、")}
                </Text>
              )}
            </YStack>
            <Text fontSize={14} fontWeight="800" color={v2.title} style={tabular}>
              {paymentDirectionPrefix(p.direction)}
              {money(p.amount)}
            </Text>
          </XStack>
        ))}
      </ListContainer>
    </YStack>
  );
}
